import { render, staticRenderFns } from "./SaveMaterialModal.vue?vue&type=template&id=7d50597e"
import script from "./SaveMaterialModal.vue?vue&type=script&lang=js"
export * from "./SaveMaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports